import React from 'react';
import { Card, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CardsKum = ({
  link, gambar, nama, tanggal, jam,
}) => (
  <>
    <Col sm="6" md="4" lg="3" className="mb-3">
      <Card style={{
        width: '13rem', backgroundColor: 'white', borderColor: 'black', borderWidth: 'thin',
      }}
      >
        <Card.Img style={{ width: '13rem', height: '15rem', padding: '10px' }} variant="top" src={gambar} />
        <Card.Body>
          <Card.Title style={{ fontSize: '23px' }}>{nama}</Card.Title>
          <Card.Text>
            {tanggal}
            |
            {jam}
          </Card.Text>
          <div className="w-100 text-center">
            <Button style={{ backgroundColor: '#F9B114' }} href={`DetailKum/${link}`}>View Details</Button>
          </div>
        </Card.Body>
      </Card>
    </Col>
  </>
);

CardsKum.defaultProps = {
  gambar: '',
  nama: '',
  tanggal: '',
  jam: '',
  link: '',
};

CardsKum.propTypes = {
  gambar: PropTypes.string,
  nama: PropTypes.string,
  tanggal: PropTypes.string,
  jam: PropTypes.string,
  link: PropTypes.string,
};

export default CardsKum;
